import React from 'react';

const rows = [
  {
    left: "차단 기술",
    trueEP: "알려지지 않은 공격까지 근원적으로 방어하는 자체 특허기술",
    others: "공격이 알려지면 막는 방식을 추가하는 방식",
  },
  {
    left: "언노운 공격 방어",
    trueEP: "패치 없이 차단",
    others: "패치한 후에야 차단",
  },
  {
    left: "검증",
    trueEP: "Since 2006",
    others: "패치 시 마다 다시 검증",
  },
  {
    left: "부하",
    trueEP: "가볍다",
    others: "무겁다",
  },
];

const TrueEPComparison = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>제품개요</h2>
      <div className={styles.divider} />

      <h3 className={styles.h3}>
        <span className={styles.compareLine} />
        전통적 방어체계와의 비교
        <span className={styles.compareLine} />
      </h3>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th} style={{ width: 180 }}>구분</th>
              <th className={styles.th}>trueEP</th>
              <th className={styles.th}>Others</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx}>
                <td className={styles.tdHead}>{r.left}</td>
                <td className={styles.td}>{r.trueEP}</td>
                <td className={styles.td}>{r.others}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ul className={styles.bullets}>
        <li>
          세계 최초이며 유일한 신개념 악성행위 차단 솔루션으로 <u>현재까지의 보안개념과는 차원이 다른 제품</u>입니다.
        </li>
        <li>
          트루컷시큐리티는 악성행위 차단기술 중에서도 가장 난이도가 높고 궁극의 개념인 <u>Human-Interaction기반 악성행위 차단기술</u>의 특허권자입니다.
          {`\n이 기술은 컴퓨터의 동작원리와 원격지 공격자의 한계를 이용하여 `}<u>{`알려지지 않은(Unknown) 공격을 근원적으로 차단하는 혁신 기술`}</u>{`입니다.`}
        </li>
      </ul>
    </section>
  )
}

export default TrueEPComparison